import { freeze, merge } from 'icepick';

import { SET } from './actions';
import { type ActivationState } from './types';
import { type AnyAction } from 'redux';
import {
	CHECK_ACTIVATION_STATUS,
	START_ACTIVATION,
	UPDATE_ACTIVATION_STATUS,
} from '../actions/activate-confluence';

export const initialContextState: ActivationState = freeze({
	status: 'not-started',
	retryCount: 0,
	userInitiated: false,
});

export default (
	state: ActivationState = initialContextState,
	action: AnyAction,
): ActivationState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		case UPDATE_ACTIVATION_STATUS: {
			return merge(state, {
				status: action.payload.status,
			});
		}
		case START_ACTIVATION: {
			return merge(state, {
				status: 'activating',
				userInitiated: true,
			});
		}
		case CHECK_ACTIVATION_STATUS: {
			return merge(state, {
				retryCount: state.retryCount + 1,
			});
		}
		default:
			return state;
	}
};
